import React, { useState, useEffect , useContext } from "react";
import {AuthContext} from "../../../../context/AuthContext";
import {fetchWithAuth} from "../../../../utils/api";
import ManageClasses from "./ManageClasses";
import ManagePeriods from "./ManagePeriods";
import ManageTestTypes from "./ManageTestTypes";
import ManageRubrics from "./ManageRubrics";
import ManageGradeLetters from "./ManageGradeLetters";
import "../../../../App.css";
import ManageLevels from "./ManageLevels";
import ManageSubjects from "./ManageSubjects";
import {swalError} from "../../../../utils/swalAlert";

const TAB_KEY = "manageAcademicsActiveTab";


const ManageAcademics = () => {
  const [activeTab, setActiveTab] = useState(
    () => localStorage.getItem(TAB_KEY) || "periods"
  );
  const [instituteInfo,setInstituteInfo] = useState(null);
    const { user } = useContext(AuthContext);
    const serverUrl = `${process.env.REACT_APP_SERVER_URL}`;


  useEffect(() => {
    const fetchInstitute = async () => {
      try {
        const response = await fetchWithAuth(
          `${serverUrl}/api/institute/get/${user.instituteId}`,
        );
        if (!response) return;
        if (!response.ok) throw new Error("Failed to fetch institute data");
        const data = await response.json();
        setInstituteInfo(data);
      } catch (err) {
        swalError("Failed to load institute data.");
      } 
    };
    fetchInstitute();
  }, [user.instituteId,serverUrl]);


  useEffect(() => {
    localStorage.setItem(TAB_KEY, activeTab);
  }, [activeTab]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "periods":
        return <ManagePeriods />;
      case "classes":
        return <ManageClasses />;
      case "rubrics":
        return <ManageRubrics />;
      case "testTypes":
        return <ManageTestTypes />;
      case "levels":
        return <ManageLevels/>
      case "subjects":
        return <ManageSubjects />;
      case "gradeLetters":
        return <ManageGradeLetters />;
      default:
        return null;
    }
  };

  const isLanguageInst = instituteInfo?.category === "LANGUAGE_LEARNING_INSTITUTE";

  return (
    <div className="manage-academics-container">
      <div className="tabs">
        <button
          className={`tab-btn ${activeTab === "periods" ? "active" : ""}`}
          onClick={() => setActiveTab("periods")}
        >
          Periods
        </button>
        <button
          className={`tab-btn ${activeTab === "classes" ? "active" : ""}`}
          onClick={() => setActiveTab("classes")}
        >
          {isLanguageInst ? "Batches" : "Classes"}
        </button>
        <button
          className={`tab-btn ${activeTab === "rubrics" ? "active" : ""}`}
          onClick={() => setActiveTab("rubrics")}
        >
          Rubrics
        </button>
        <button
          className={`tab-btn ${activeTab === "testTypes" ? "active" : ""}`}
          onClick={() => setActiveTab("testTypes")}
        >
          Test Types
        </button>
        <button
          className={`tab-btn ${activeTab === "levels" ? "active" : ""}`}
          onClick={() => setActiveTab("levels")}
        >
          Levels
        </button>
        {instituteInfo?.category !== "HIGHER_EDUCATION" && (
        <button
          className={`tab-btn ${activeTab === "subjects" ? "active" : ""}`}
          onClick={() => setActiveTab("subjects")}
        >
          Subjects
        </button>
        )}
        <button
          className={`tab-btn ${activeTab === "gradeLetters" ? "active" : ""}`}
          onClick={() => setActiveTab("gradeLetters")}
        >
          Grade Letters
        </button>
      </div>

      <div className="tab-content">{renderActiveTab()}</div>
    </div>
  );
};

export default ManageAcademics;